const testRoutes = ($stateProvider) => {
  $stateProvider.state('helloWorld', {
    url: '/hello-world',
    template: '<h1>Hello World</h1>',
  });
};

export default testRoutes;
